export class StickyResolver {
    constructor(stickyElement) {
        this.stickyElement = stickyElement;
        this.stickyTos = document.querySelectorAll('.sticky');

        if (this.stickyElement && this.stickyTos.length > 0) {
            this.resolve();
        }
    }

    resolve() {
        let stickyPosition = 10;
        
        this.stickyTos.forEach(stickyTo => {
            stickyPosition += stickyTo.clientHeight;
        });

        this.stickyElement.style.top = stickyPosition + 'px';
    }
}